const dictionaryTypes = [
  { label: 'Incendio y Adicionales', value: 'dictionary_1' },
  { label: 'Vehículos', value: 'dictionary_2' }
];

export default dictionaryTypes;
